// extracted by mini-css-extract-plugin
export var share = "bg_dv";
export var text = "bg_dw";